// extracted by mini-css-extract-plugin
export default {"chatModeTap":"ChatMode_chatModeTap__BpFAd","tapContainer":"ChatMode_tapContainer__U4-Ir","active":"ChatMode_active__8Bl1w"};